export default __webpack_public_path__ + "static/media/346.8cc37af6.jpg";